/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../../modules/es6.reflect.own-keys');
module.exports = require('../../modules/$.core').Reflect.ownKeys;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/reflect/own-keys.js
 ** module id = 1324
 ** module chunks = 0
 **/